import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Button as ButtonMemoized } from '../Button/Button.js';
import { Typography } from '../Typography/Typography.js';
import { defaultProps, decreaseButtonPropsMapper, typographyPropsMapper, increaseButtonPropsMapper } from './Counter.mappers.js';

var _excluded = ["value", "state", "min", "max", "onChange", "decreaseButtonProps", "increaseButtonProps", "textProps"];
/**
 * Counters are used to increase or decrease numerical values.
 */
var Counter = /*#__PURE__*/React.memo(function (_ref) {
  var value = _ref.value,
    state = _ref.state,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? defaultProps.min : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? defaultProps.max : _ref$max,
    onChange = _ref.onChange,
    decreaseButtonProps = _ref.decreaseButtonProps,
    increaseButtonProps = _ref.increaseButtonProps,
    textProps = _ref.textProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(value || 0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    internalValue = _React$useState2[0],
    setInternalValue = _React$useState2[1];
  React.useEffect(function () {
    if (value !== undefined && value !== internalValue) {
      setInternalValue(value);
    }
  }, [value, internalValue]);
  var handleValueChange = function handleValueChange(newValue) {
    setInternalValue(newValue);
    onChange === null || onChange === void 0 || onChange(newValue);
  };
  var currentValue = value !== undefined ? value : internalValue;
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12"
  }, rest), /*#__PURE__*/React.createElement(ButtonMemoized, decreaseButtonPropsMapper(currentValue, min, handleValueChange, state, decreaseButtonProps)), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    role: "status",
    "aria-live": "assertive"
  }, /*#__PURE__*/React.createElement(Typography, typographyPropsMapper(state, textProps), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "2ch"
  }, currentValue))), /*#__PURE__*/React.createElement(ButtonMemoized, increaseButtonPropsMapper(currentValue, max, handleValueChange, state, increaseButtonProps)));
});
Counter.defaultProps = defaultProps;

export { Counter };
//# sourceMappingURL=Counter.js.map
